import { productPageTabLabels } from "../../../strings/labels";
import { ListingPageLayoutProps } from "../../../types/ui-types";
import { getItemTypeColor } from "../../../utils/colors";
import { Card } from "../Card/Card";

export const LayoutProduct = ({
  listing,
  location,
  enrichedConnections = [],
}: ListingPageLayoutProps) => {
  // Filter to only show connections where this product is the object
  // (members point TO the product as creators/contributors/customers)
  const objectConnections = enrichedConnections.filter(
    (ec) => !ec.connection.isSubject
  );

  // Separate by role type
  const creators = objectConnections.filter(
    (ec) => ec.connection.roleType === "creator"
  );

  const contributors = objectConnections.filter(
    (ec) => ec.connection.roleType === "collaborator"
  );

  const customers = objectConnections.filter(
    (ec) => ec.connection.roleType === "participant"
  );

  // Helper to get label for each role
  const getLabel = (roleType: string) => {
    const label = productPageTabLabels.find((l) => l.type === roleType);
    return label?.label || roleType;
  };

  return (
    <div className="listing-wrapper">
      {/* Cover Image */}
      {listing.coverImgUrl && (
        <div className="listing-cover-image">
          <img src={listing.coverImgUrl} alt={`${listing.name} cover`} />
        </div>
      )}

      <div className="listing-detail-container">
        {/* Sidebar */}
        <aside className="listing-sidebar">
          {listing.imageUrl && (
            <div className="listing-profile-image">
              <img src={listing.imageUrl} alt={listing.name} />
            </div>
          )}

          <h1 className="listing-name">{listing.name}</h1>

          {location && (
            <div className="listing-location">
              <span className="listing-location-icon">📍</span>
              <span>{location.placeName}</span>
            </div>
          )}

          {listing.url && (
            <a
              href={listing.url}
              target="_blank"
              rel="noopener noreferrer"
              className="listing-website-link"
            >
              {listing.url.replace(/^https?:\/\//, "")}
            </a>
          )}
        </aside>

        {/* Main Content Area */}
        <main className="listing-content">
          {/* Description */}
          {listing.description && (
            <div className="listing-description">
              <p>{listing.description}</p>
            </div>
          )}

          {/* Creators Section */}
          {creators.length > 0 && (
            <div className="listing-people-section">
              <h3 className="listing-section-title">{getLabel("creator")}</h3>
              <div className="listing-people-grid">
                {creators.map((ec) => (
                  <Card
                    key={ec.listing.id}
                    listingId={ec.listing.id}
                    listingUserId={ec.listing.userId || ""}
                    imageUrls={[
                      ec.listing.imageUrl || ec.listing.coverImgUrl || "",
                    ]}
                    title={ec.listing.name}
                    type={ec.listing.subType}
                    subTypeLabel={ec.listing.subType || "other"}
                    typeColor={getItemTypeColor(ec.listing.itemType)}
                    onClick={() => {
                      const itemType =
                        ec.listing.itemType === "person"
                          ? "members"
                          : "offering";
                      window.location.href = `/${itemType}/${ec.listing.id}`;
                    }}
                  >
                    <div className="card-location">
                      {ec.listing.locationName}
                    </div>
                    <div className="card-description">
                      {ec.listing.description}
                    </div>
                  </Card>
                ))}
              </div>
            </div>
          )}

          {/* Contributors Section */}
          {contributors.length > 0 && (
            <div className="listing-people-section">
              <h3 className="listing-section-title">
                {getLabel("collaborator")}
              </h3>
              <div className="listing-people-grid">
                {contributors.map((ec) => (
                  <Card
                    key={ec.listing.id}
                    listingId={ec.listing.id}
                    listingUserId={ec.listing.userId || ""}
                    imageUrls={[
                      ec.listing.imageUrl || ec.listing.coverImgUrl || "",
                    ]}
                    title={ec.listing.name}
                    type={ec.listing.subType}
                    subTypeLabel={ec.listing.subType || "other"}
                    typeColor={getItemTypeColor(ec.listing.itemType)}
                    onClick={() => {
                      const itemType =
                        ec.listing.itemType === "person"
                          ? "members"
                          : "offering";
                      window.location.href = `/${itemType}/${ec.listing.id}`;
                    }}
                  >
                    <div className="card-location">
                      {ec.listing.locationName}
                    </div>
                    <div className="card-description">
                      {ec.listing.description}
                    </div>
                  </Card>
                ))}
              </div>
            </div>
          )}

          {/* Customers Section */}
          {customers.length > 0 && (
            <div className="listing-people-section">
              <h3 className="listing-section-title">
                {getLabel("participant")}
              </h3>
              <div className="listing-people-grid">
                {customers.map((ec) => (
                  <Card
                    key={ec.listing.id}
                    listingId={ec.listing.id}
                    listingUserId={ec.listing.userId || ""}
                    imageUrls={[
                      ec.listing.imageUrl || ec.listing.coverImgUrl || "",
                    ]}
                    title={ec.listing.name}
                    type={ec.listing.subType}
                    subTypeLabel={ec.listing.subType || "other"}
                    typeColor={getItemTypeColor(ec.listing.itemType)}
                    onClick={() => {
                      const itemType =
                        ec.listing.itemType === "person"
                          ? "members"
                          : "offering";
                      window.location.href = `/${itemType}/${ec.listing.id}`;
                    }}
                  >
                    <div className="card-location">
                      {ec.listing.locationName}
                    </div>
                    <div className="card-description">
                      {ec.listing.description}
                    </div>
                  </Card>
                ))}
              </div>
            </div>
          )}
        </main>
      </div>
    </div>
  );
};
